import styled from 'styled-components'

export const SidebarFooter = styled.div`
  flex-shrink: 0;
  padding: 12px 14px 10px;
  font-size: 11px;
  line-height: 1.45;
  color: #6b7280;
  border-top: 1px solid #e5e7eb;
  background: #fafafa;

  .sidebar-footer-line {
    margin-bottom: 2px;
  }

  .sidebar-footer-version {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
    font-size: 10px;
    color: #9ca3af;
    word-break: break-all;
    margin-top: 4px;
  }
`

export const Wrapper = styled.aside`
  background: #ffffff;
  box-shadow: 1px 0 0 #e5e7eb;
  max-width: 220px;

  position: fixed;
  left: 0;
  bottom: 0;
  top: 63px;
  z-index: 22;

  visibility: ${({ sidebarCompact }) => (sidebarCompact ? 'visible' : 'hidden')};
  transform: translate(${({ sidebarCompact }) => (sidebarCompact ? 0 : '-250px')});
  width: ${({ sidebarCompact }) => (sidebarCompact ? '100%' : '0')};
  transition: transform .3s linear, visibility .3s linear, width .2s linear;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .sidebar-menu-wrap {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }

  .gav-sidebar-menu.ant-menu-light {
    background: #ffffff;
    border-right: none;
    color: #111827;
  }

  .gav-sidebar-menu .ant-menu-submenu-title {
    color: #111827 !important;
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0.02em;
  }

  .gav-sidebar-menu .ant-menu-item {
    color: #374151 !important;
    margin: 2px 0 !important;
    height: auto !important;
    line-height: 1.4 !important;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }

  .gav-sidebar-menu .ant-menu-item a {
    color: inherit;
    display: block;
  }

  .gav-sidebar-menu .ant-menu-item-selected {
    background: #f3f4f6 !important;
  }

  .gav-sidebar-menu .ant-menu-item-active {
    background: #f9fafb !important;
  }

  .gav-sidebar-menu .ant-menu-submenu-arrow {
    color: #9ca3af;
  }

  .collapse {
    max-height: 40px;
    line-height: 40px;
    text-align: left;
    box-shadow: inset 0 1px 0 #e5e7eb;
    padding: 0 16px;
    color: #6b7280;

    border: none;
    background: #fafafa;
  }

  .collapse:hover {
    color: #111827;
    background: #f3f4f6;
  }

  .menu-active {
    display: block;
    font-weight: 600;
    box-shadow: inset -3px 0 0 #3b82f6;
    border-radius: 4px;
    background: #eff6ff;
  }

  li {
    margin: 0 !important;

    &.ant-menu-item {
      display: flex;
      align-items: center;
    }

    &.ant-menu-item-active:not(.ant-menu-horizontal),
    &.ant-menu-item-selected:not(.ant-menu-horizontal) {
      background: transparent;
      color: #111827;

      .ant-menu-title-content {
        color: #111827;
      }
    }
  }
`

export const Ul = styled.ul`
  padding: 0;
  margin-bottom: 0;

  .navigation {
    .navigation-item {
      padding: ${({ sidebarCompact, sidebarHover }) => (sidebarCompact && !sidebarHover ? '0.375rem 0 0 0' : '0.375rem 0 0 0.75rem')};
    }
  }
`

export const Li = styled.li`
  list-style: none;
  cursor: pointer;
  display: list-item;
  user-select: none;
  transition: opacity 0.2s;
  color: ${({ theme }) => theme.white};
  padding: ${({ sidebarCompact, sidebarHover }) => (sidebarCompact && !sidebarHover ? '.2rem 0' : '.2rem .75rem')};
  transition: all .2s ease-in-out;

  .navigation-title {
    padding: 0 0.75rem;
    display: block;
    color: rgba(231,238,248,.6);
    font-size: .8rem;
    font-weight: 600;
    line-height: 1rem;
  }

  a.navigation-link {
    position: relative;
    color: ${({ theme }) => theme.text_hight_light};
    padding: ${({ sidebarCompact, sidebarHover }) => (sidebarCompact && !sidebarHover ? '.5rem' : '.75rem')};
    display: flex;
    justify-content: ${({ sidebarCompact, sidebarHover }) => (sidebarCompact && !sidebarHover ? 'center' : 'space-between')};
    align-items: center;
    font-weight: 600;
    font-size: ${({ sidebarCompact, sidebarHover }) => (sidebarCompact && !sidebarHover ? 0 : '.7rem')};
    width: ${({ sidebarCompact, sidebarHover }) => (sidebarCompact && !sidebarHover ? '70%' : '100%')};
    margin: 0 auto;

    .navigation-link-info {
      display: flex;
      align-items: center;
      .navigation-icon {
        margin-right: ${({ sidebarCompact, sidebarHover }) => (sidebarCompact && !sidebarHover ? 0 : '.75rem')};
        width: calc(1rem + .3vw);
        font-size: 1.1rem;
      }
    }

    .navigation-link-extra {
      font-size: ${({ sidebarCompact, sidebarHover }) => (sidebarCompact && !sidebarHover ? '.8rem' : '1rem')};
      display: flex;
      align-items: center;
      .svg-icon--material {
        fill: currentColor;
        position: ${({ sidebarCompact, sidebarHover }) => (sidebarCompact && !sidebarHover ? 'absolute' : 'unset')};
        right: ${({ sidebarCompact, sidebarHover }) => (sidebarCompact && !sidebarHover ? 0 : 'unset')};

        &.down {
          transform: rotate(90deg);
        }
      }
    }

    &.active {
      color: ${({ theme }) => theme.text_hight_light};
      background-color: ${({ theme }) => theme.bg_hight_light};
      border-radius: 1rem;
    }

    &:hover {
      opacity: 0.8;
      color: ${({ theme }) => theme.text_hight_light};
      background-color: ${({ theme }) => theme.bg_hight_light};
      border-radius: 1rem;
      width: ${({ sidebarCompact, sidebarHover }) => (sidebarCompact && !sidebarHover ? '70%' : '100%')};
      margin: 0 auto;

      .navigation-icon {
        stroke: ${({ theme, stroke }) => theme[stroke]};
      }
    }
  }
`
